import React, { useState } from 'react'
import { Modal, message } from 'antd';
import { DropzoneArea } from 'material-ui-dropzone';

import { url } from "../Constent/Constant";

const PlanSection = ({ Heading, Para, HeadingId, ParaId, CardData, UpdateImage, UpdateText }) => {
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [ImageModal, setImageModal] = useState(false);
    const [UpdateId, setUpdateId] = useState('')

    const ShowTextModal = (id) => {
        setTextModalVisible(true);
        setUpdateId(id)
    };

    const showImageModal = (id) => {
        setImageModal(true);
        setUpdateId(id)
    };


    const TextHandle = () => {
        if (HeadingUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: HeadingUpdate,
                id: UpdateId
            })
            setTextModalVisible(false);
            setHeadingUpdate('')
        }
    };

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: UpdateId
            })
            setImageModal(false);
        }
    };

    const handleCancel = () => {
        setTextModalVisible(false);
        setImageModal(false);
    };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if (event.key === 'Enter') {
            console.log('Enter Clicked')
            a.concat('\n')
            setHeadingUpdate(a)
        } else {
            console.log(event.key)
        }
    }

    return (
        <div className='Plan-Container'>
            {Heading && <h2 className='Heading'> {Heading ? Heading : ''}
                <i onClick={() => ShowTextModal(HeadingId)} className="far fa-edit Edit-btn"></i>
            </h2>}
            {Para ? (<p>{Para}
                <i onClick={() => ShowTextModal(ParaId)} className="far fa-edit Edit-btn"></i>
            </p>) : ''}
            <div className='Plan-Cards'>
                <div className='Card'>
                    {CardData.Card1.img && <div className='Card-Img'>
                        <i onClick={() => showImageModal(CardData.card1.imgId)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.Card1.img}`} alt='Icon' draggable='false' />
                    </div>}
                    <div className='Card-box'>
                        <h3>{CardData ? CardData.Card1.heading : 'No Text'}
                            <i onClick={() => ShowTextModal(CardData.Card1.headingId)} className="far fa-edit Edit-btn"></i>
                        </h3>
                        <div className='Para-div'>
                            <i onClick={() => ShowTextModal(CardData.Card1.paraId)} className="far fa-edit Edit-btn"></i>
                            <p> {CardData ? CardData.Card1.para : 'No Text'} </p>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    {CardData.Card2.img && <div className='Card-Img'>
                        <i onClick={() => showImageModal(CardData.card2.imgId)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.Card2.img}`} alt='Icon' draggable='false' />
                    </div>}
                    <div className='Card-box'>
                        <h3>{CardData ? CardData.Card2.heading : 'No Text'}
                            <i onClick={() => ShowTextModal(CardData.Card2.headingId)} className="far fa-edit Edit-btn"></i>
                        </h3>
                        <div className='Para-div'>
                            <i onClick={() => ShowTextModal(CardData.Card2.paraId)} className="far fa-edit Edit-btn"></i>
                            <p> {CardData ? CardData.Card2.para : 'No Text'} </p>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    {CardData.Card3.img && <div className='Card-Img'>
                        <i onClick={() => showImageModal(CardData.card3.imgId)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.Card3.img}`} alt='Icon' draggable='false' />
                    </div>}
                    <div className='Card-box'>
                        <h3>{CardData ? CardData.Card3.heading : 'No Text'}
                            <i onClick={() => ShowTextModal(CardData.Card3.headingId)} className="far fa-edit Edit-btn"></i>
                        </h3>
                        <div className='Para-div'>
                            <i onClick={() => ShowTextModal(CardData.Card3.paraId)} className="far fa-edit Edit-btn"></i>
                            <p> {CardData ? CardData.Card3.para : 'No Text'} </p>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    {CardData.Card4.img && <div className='Card-Img'>
                        <i onClick={() => showImageModal(CardData.card4.imgId)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.Card4.img}`} alt='Icon' draggable='false' />
                    </div>}
                    <div className='Card-box'>
                        <h3>{CardData ? CardData.Card4.heading : 'No Text'}
                            <i onClick={() => ShowTextModal(CardData.Card4.headingId)} className="far fa-edit Edit-btn"></i>
                        </h3>
                        <div className='Para-div'>
                            <i onClick={() => ShowTextModal(CardData.Card4.paraId)} className="far fa-edit Edit-btn"></i>
                            <p> {CardData ? CardData.Card4.para : 'No Text'} </p>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    {CardData.Card5.img && <div className='Card-Img'>
                        <i onClick={() => showImageModal(CardData.card5.imgId)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.Card5.img}`} alt='Icon' draggable='false' />
                    </div>}
                    <div className='Card-box'>
                        <h3>{CardData ? CardData.Card5.heading : 'No Text'}
                            <i onClick={() => ShowTextModal(CardData.Card5.headingId)} className="far fa-edit Edit-btn"></i>
                        </h3>
                        <div className='Para-div'>
                            <i onClick={() => ShowTextModal(CardData.Card5.paraId)} className="far fa-edit Edit-btn"></i>
                            <p> {CardData ? CardData.Card5.para : 'No Text'} </p>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    {CardData.Card6.img && <div className='Card-Img'>
                        <i onClick={() => showImageModal(CardData.card6.imgId)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.Card6.img}`} alt='Icon' draggable='false' />
                    </div>}
                    <div className='Card-box'>
                        <h3>{CardData ? CardData.Card6.heading : 'No Text'}
                            <i onClick={() => ShowTextModal(CardData.Card6.headingId)} className="far fa-edit Edit-btn"></i>
                        </h3>
                        <div className='Para-div'>
                            <i onClick={() => ShowTextModal(CardData.Card6.paraId)} className="far fa-edit Edit-btn"></i>
                            <p> {CardData ? CardData.Card6.para : 'No Text'} </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
            </Modal>

            {/* Update Image Modal */}
            <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>

        </div>
    )
}

export default PlanSection
